export default {
  buttons: {
    save: 'Gem',
    confirm: 'Bekræft',
    cancel: 'Annuller',
  },
  confirmation: {
    title: 'Er du sikker på, at du vil synkronisere til eksterne tjenester?',
  },
};
